export class PaginationService {
    static $inject = ['LoadingService'];
    constructor(LoadingService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.page = 1;
        this.skip = 0;
        this.totalNumberPages = 1;
        this.totalNumberItems = 40;
        this.itemsPerPage = 40;
        this.listItemsPerPage = [40, 80, 120];
        this.showPagination = false;
    }
    initialize(itemsPerPage = 40) {
        this.page = 1;
        this.skip = 0;
        this.totalNumberPages = 1;
        this.totalNumberItems = 40;
        this.itemsPerPage = itemsPerPage;
        this.showPagination = false;
    }
    calculatePagination(items) {
        this.LoadingService.startLoading();
        const total = items.length;
        this.totalNumberPages = total ? Math.ceil(total / this.itemsPerPage) : 1;
        this.totalNumberItems = total;
        this.showPagination = total > this.itemsPerPage;
        this.LoadingService.stopLoading();
    }
    getCurrentPageItems(items, isSkipPage = false) {
        if (isSkipPage) {
            return items.slice(this.skip, this.skip + this.itemsPerPage);
        }
        return items.slice(0, this.itemsPerPage);
    }
    changePage(page) {
        this.page = page;
        this.skip = (page - 1) * this.itemsPerPage;
    }
    changeItemsPerPage(newItemsPerPage) {
        this.itemsPerPage = newItemsPerPage;
        this.totalNumberPages = 1;
        this.totalNumberItems = 40;
    }
}
PaginationService.$inject = ['LoadingService'];
